import { ComponentType } from 'react';
import { SchedulesAdmin } from './schedules-admin';

export const Schedules: ComponentType = () => {
  return <SchedulesAdmin />;
};
